import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LeafAngularWrapper } from '../leaf-angular-wrapper';

import '@esi/leaf-web/lib/wc/components/tab/tab';

@Component({
  selector: 'cigna-leaf-tab',
  template: `
    <leaf-tab>
      <ng-content></ng-content>
    </leaf-tab>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CignaLeafTabComponent extends LeafAngularWrapper {}
